import { ICpiRange } from "./ICpiRange";

export interface ICost {
  currency: string;
  cpi: number;
  cpiRanges: Array<ICpiRange>;
}

export interface ICostByFieldDuration {
  [fieldDuration: string]: ICost;
}

export class Cost implements ICost {
  currency: string;
  cpi: number;
  cpiRanges: Array<ICpiRange>;

  constructor() {
    this.currency = "EUR";
    this.cpiRanges = [];
  }

}



// WEBPACK FOOTER //
// ./src/app/models/ICost.ts